import { useTranslation } from 'react-i18next';

const STEP_COUNT = 3;
const stepIndices = Array.from({ length: STEP_COUNT }, (_, i) => i);

function renderParagraphs(text: string, className: string) {
  return text.split(/\n{2,}/).map((paragraph, index) => (
    <p key={index} className={className}>
      {paragraph}
    </p>
  ));
}

export default function LearningProgression() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-8">
        <div className="text-center mb-12">
          {renderParagraphs(
            t('coursesMaster.progression.label'),
            "text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label",
          )}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesMaster.progression.title')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {renderParagraphs(
            t('coursesMaster.progression.lead'),
            "text-[16px] text-foreground-600 tracking-[0.04em] max-w-xl mx-auto leading-relaxed",
          )}
        </div>

        <div className="space-y-6">
          {stepIndices.map((index) => (
            <div
              key={index}
              className="flex gap-5 md:gap-6 items-start bg-background-50 border border-background-200/60 p-6 md:p-7"
            >
              <span className="flex-shrink-0 w-10 h-10 rounded-full bg-accent-500/10 border border-accent-500/30 flex items-center justify-center font-heading text-accent-600 text-[15px]">
                {index + 1}
              </span>
              <div>
                <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-2">
                  {t(`coursesMaster.progression.${index}.title`)}
                </h3>
                {renderParagraphs(
                  t(`coursesMaster.progression.${index}.description`),
                  "text-[15px] text-foreground-700 leading-relaxed tracking-[0.03em]",
                )}
              </div>
            </div>
          ))}
        </div>

        {renderParagraphs(
          t('coursesMaster.progression.note'),
          "text-[13px] text-foreground-500 tracking-[0.04em] mt-6 text-center",
        )}
      </div>
    </section>
  );
}
